// extracted by mini-css-extract-plugin
export default {"contactHero":"LetsConnect_contactHero__Oqs1P","social":"LetsConnect_social__upu+f"};